export default {
  Login: "Login",
  "Sign in": "Sign in"
};
